var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgTimeClock = function SvgTimeClock(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.0625 16.5C2.0625 20.3291 3.58359 24.0013 6.29115 26.7089C8.9987 29.4164 12.6709 30.9375 16.5 30.9375C20.3291 30.9375 24.0013 29.4164 26.7089 26.7089C29.4164 24.0013 30.9375 20.3291 30.9375 16.5C30.9375 12.6709 29.4164 8.9987 26.7089 6.29115C24.0013 3.58359 20.3291 2.0625 16.5 2.0625C12.6709 2.0625 8.9987 3.58359 6.29115 6.29115C3.58359 8.9987 2.0625 12.6709 2.0625 16.5V16.5Z",
    stroke: "url(#paint0_linear_666_30)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 16.5V11.3438",
    stroke: "url(#paint1_linear_666_30)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 16.5L22.9446 22.946",
    stroke: "url(#paint2_linear_666_30)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_666_30",
    x1: 30.9375,
    y1: 16.7292,
    x2: 2.0625,
    y2: 16.7292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DD3C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C5F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_666_30",
    x1: 17.5,
    y1: 13.9628,
    x2: 16.5,
    y2: 13.9628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DD3C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C5F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_666_30",
    x1: 22.9446,
    y1: 19.7742,
    x2: 16.5,
    y2: 19.7742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DD3C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C5F1"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTimeClock);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,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";